module.exports = __webpack_public_path__ + "static/media/flag-alt.d0881626.svg";